module.exports = __webpack_public_path__ + "media/A2.ee902eca.mp3";